import React from "react";
import LinkComp from "../LinkComp/LinkComp";

export default ({title, isSmall, id}) => (
    <div className={`circle-container${isSmall ? ' small' : ''}`}>
        <div className='outer-circle'>
            <LinkComp to={`${arc.path.base}training/brokerage-continuum/${id}`}>
                <div className='upper-semicircle'/>
                <div className='lower-semicircle'/>
                <div className='inner-circle'/>
                <div className='chapters'>{title}</div>
            </LinkComp>
        </div>
    </div>
);